module.exports = __webpack_public_path__ + "static/media/shells_header_logo.36aa320e.svg";